<section class="clarification">
  <router-outlet />
</section>
